import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import ExecucaoAuditoriaService from "service/auditoria5s/ExecucaoAuditoriaService";
import ItemAuditoriaService from "service/auditoria5s/ItemAuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData } from "utils/convert";
import ModalRespostaItemAuditoria from "./modal/ModalRespostaItemAuditoria";

const auditoriaService = new AuditoriaService();
const execucaoAuditoriaService = new ExecucaoAuditoriaService();
const itemAuditoriaService = new ItemAuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();
export default function AuditoriaExecutarPage() {

    const [refreshing, setRefreshing] = useState(false);

    const [auditoria, setAuditoria] = useState<Auditoria>(new Auditoria());
    const [podeCancelar, setPodeCancelar] = useState(false);
    const [visibleOpcaoNaoAplicavel, setVisibleOpcaoNaoAplicavel] = useState(false);
    const [title, setTitle] = useState('Auditoria');

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgAlerta } = useToastContext();

    const navigate = useNavigate();

    const [visibleModalCancelarAuditoria, setVisibleModalCancelarAuditoria] = useState(false);
    const [modalRespostaItem, setModalRespostaItem] = useState<{ visible: boolean, data: ItemClasseAuditoria | null, conforme: boolean }>({ visible: false, data: null, conforme: false });

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        load();
        execucaoAuditoriaService.temOpcaoNaoAplicavel().then((json) => {
            setVisibleOpcaoNaoAplicavel(json);
        }).catch(error => {
            console.error(error);
        })
        usuarioLogadoService.getAcoesUsuarioLogado().then(json => {
            json.find((acao) => acao.sigla === 'AUDITORIA_CANCELAR') ? setPodeCancelar(true) : setPodeCancelar(false);
        }).catch(err => {
            console.error(err);
        });

    }, []);

    function load() {
        startLoading();
        let id = window.location.pathname.substring(`/minhasAuditorias/executar/`.length)
        auditoriaService.consultar(parseInt(id)).then(json => {
            stopLoading();
            setAuditoria(json);

            setTitle('Auditoria nº ' + json.numero)

        }).catch(err => {
            stopLoading();
            setAuditoria(new Auditoria());
            console.error(err);
        });

    }
    function navigateToItem(item: ItemClasseAuditoria) {
        navigate("/minhasAuditorias/executar/item/" + item.id);
    }

    function selecionarItemAuditoria(item: ItemClasseAuditoria) {
        if (item.status === 'CRIADO') {
            itemAuditoriaService.iniciarItemAuditoria(item).then(json => {
                navigateToItem(item);
            }).catch(e => {
                if (e && e.data && e.data.message) {
                    msgAlerta('', e.data.message);
                } else {
                    msgAlerta('', 'Ocorreu um erro ao tentar iniciar item');
                }
            });
        } else {
            navigateToItem(item);
        }

    }

    function finalizarAuditoria() {


        startLoading();
        execucaoAuditoriaService.finalizar(auditoria).then(() => {
            stopLoading();
            load();
        }).catch(e => {
            console.warn(e);

            stopLoading();
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar finalizar esta auditoria');
            }

        });

    }

    function salvarObservacao() {
        execucaoAuditoriaService.salvarObservacao(auditoria).then(() => {
        }).catch(e => {
            console.warn(e);
        });
    }

    const marcarConforme = (item: ItemClasseAuditoria) => {
        itemAuditoriaService.marcarConforme(item).then(json => {
            item.status = "FINALIZADO";
            item.ultimaExecucao = new Date();
            item.resultado = "CONFORME";
            setAuditoria({ ...auditoria });
        }).catch(e => {
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar marcar item como conforme');
            }
        });
    }

    const marcarNaoConforme = (item: ItemClasseAuditoria) => {
        itemAuditoriaService.marcarNaoConforme(item).then(json => {
            item.status = "EM_ANDAMENTO";
            item.resultado = "NAO_CONFORME";
            setAuditoria({ ...auditoria });
        }).catch(e => {
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar marcar item como não conforme');
            }
        });
    }

    const marcarNaoAplicavel = (item: ItemClasseAuditoria) => {
        itemAuditoriaService.marcarNaoAplicavel(item).then(json => {
            item.status = "FINALIZADO";
            item.resultado = "NAO_APLICAVEL";
            setAuditoria({ ...auditoria });
        }).catch(e => {
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar marcar item como não aplicavel');
            }
        });
    }

    const cancelarAuditoria = () => {
        startLoading();
        execucaoAuditoriaService.cancelar(auditoria).then(() => {
            stopLoading();
            load();
        }).catch(e => {
            console.warn(e);
            stopLoading();
            if (e && e.data && e.data.message) {
                msgAlerta('', e.data.message);
            } else {
                msgAlerta('', 'Ocorreu um erro ao tentar cancelar esta auditoria');
            }
        });
    }

    return (

        <div>

            {visibleModalCancelarAuditoria ? <ConfirmDialog
                visible={visibleModalCancelarAuditoria}
                onHide={() => setVisibleModalCancelarAuditoria(false)}
                message="Deseja realmente cancelar esta auditoria?"
                header="Cancelar auditoria"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Sim"
                rejectLabel="Não"
                accept={() => cancelarAuditoria()}
                reject={() => setVisibleModalCancelarAuditoria(false)} /> : null
            }

            {modalRespostaItem.visible ? <ModalRespostaItemAuditoria
                data={modalRespostaItem.data as ItemClasseAuditoria}
                visible={modalRespostaItem.visible}
                setVisible={(visible) => setModalRespostaItem({ visible: visible, data: null, conforme: false })}
                value={modalRespostaItem?.data as ItemClasseAuditoria}
                onChange={(value) => modalRespostaItem.data != null ?
                    setModalRespostaItem({ visible: true, data: { ...value } as ItemClasseAuditoria, conforme: modalRespostaItem.conforme })
                    : null}
                onConfirm={() => {
                    if (!modalRespostaItem.data) return;

                    let resposta = modalRespostaItem.data.resposta;
                    let item = auditoria.classesAuditoria.find(c => c.id === modalRespostaItem.data?.classeAuditoria?.id)?.itensAuditoria.find(i => i.id === modalRespostaItem.data?.id);

                    if (!item) return;
                    item.resposta = resposta;

                    if (modalRespostaItem.conforme) {
                        marcarConforme(item)
                    } else {
                        marcarNaoConforme(item)
                    }
                }}
            /> : null}

            <div >
                <h1 style={{ fontSize: 24, fontWeight: 'bold', color: '#000', marginBottom: 16 }}>{title}</h1>
                <div style={{ backgroundColor: 'transparent' }}>
                    <div style={{ padding: 8, margin: 8, backgroundColor: "#f1f4f9", display: "flex", flexDirection: "column", boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)", borderRadius: 8 }}>
                        <span style={{ fontWeight: 'bold', fontSize: 18, paddingBottom: 4 }}>Setor: {auditoria.setor?.nome}</span>
                        <span><span style={{ fontWeight: "bold" }}>Status:</span> {auditoriaService.getStatusAuditoria(auditoria.status)}</span>
                        <span><span style={{ fontWeight: "bold" }}>Itens pendentes:</span> {execucaoAuditoriaService.getTotalPendentes(auditoria)}</span>
                        <span><span style={{ fontWeight: "bold" }}>Itens realizados:</span> {execucaoAuditoriaService.getTotalRealizados(auditoria)}</span>
                        <span><span style={{ fontWeight: "bold" }}>Data limite:</span> {converterData(auditoria.dataLimite)}</span>
                    </div>
                </div>

                <div style={{ backgroundColor: 'transparent' }}>
                    <div style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 8, margin: 8 }}>

                        {auditoria.classesAuditoria.map((c, index) => {
                            return (
                                <div key={index}>
                                    <h3 style={{ fontSize: 22, paddingTop: 16, paddingBottom: 16, marginLeft: 16 }}>{c.nome}</h3>
                                    <DataTable value={c.itensAuditoria} style={{ width: '100%' }} scrollable scrollHeight="400px" emptyMessage="Nenhum registro encontrado">
                                        <Column field="nome" header="Nome" />
                                        <Column field="status" header="Status" body={(rowData) => auditoriaService.getStatusItemAuditoria(rowData.status)} style={{ width: 175 }} />
                                        <Column field="ultimaExecucao" body={(rowData) => converterData(rowData.ultimaExecucao)} header="Última execução" style={{ width: 175 }} />
                                        <Column field="resultado" header="Resultado" body={(rowData) => auditoriaService.getResultadoItemAuditoria(rowData.resultado)} style={{ width: 150 }} />
                                        <Column style={{width: 180}} body={(rowData: ItemClasseAuditoria) => {
                                            return (
                                                <div style={{ display: 'flex', flexDirection: 'row', columnGap: 8, justifyContent: 'center' }}>
                                                    {rowData.status !== "FINALIZADO" && visibleOpcaoNaoAplicavel ? <Button style={{ fontSize: 14, color: "#FFF", backgroundColor: "#AAA", width: 45, height: 45, paddingLeft: 12, borderWidth: 0 }} onClick={() => {
                                                        marcarNaoAplicavel(rowData);
                                                    }}>NA</Button> : null}
                                                    {rowData.status !== "FINALIZADO" ? <Button icon="pi pi-check" style={{ fontSize: 14, color: "#FFF", backgroundColor: "#027D07", width: 45, height: 45, borderWidth: 0 }} onClick={() => {
                                                        if (rowData.requisitoAuditoria.permiteResposta && rowData.requisitoAuditoria.respostaObrigatoria) {
                                                            setModalRespostaItem({ visible: true, data: rowData, conforme: true });
                                                        } else {
                                                            marcarConforme(rowData)
                                                        }
                                                    }} /> : null}
                                                    {rowData.status !== "FINALIZADO" ? <Button icon="pi pi-times" style={{ fontSize: 14, color: "#FFF", backgroundColor: "#F00", width: 45, height: 45, borderWidth: 0 }} onClick={() => {
                                                        if (rowData.requisitoAuditoria.permiteResposta && rowData.requisitoAuditoria.respostaObrigatoria) {
                                                            setModalRespostaItem({ visible: true, data: rowData, conforme: false });
                                                        } else {
                                                            marcarNaoConforme(rowData)
                                                        }
                                                    }} /> : null}
                                                </div>
                                            )
                                        }} />
                                        <Column style={{width: 125}} body={(rowData: ItemClasseAuditoria) => {
                                            return (
                                                <Button style={{ fontSize: 14, color: "#FFF", backgroundColor: "#0077FF", borderWidth: 0 }}
                                                    label={rowData.status === 'CRIADO' ? 'Iniciar' : rowData.status === "EM_ANDAMENTO" ? "Continuar" : 'Ver'}
                                                    onClick={() => {
                                                        selecionarItemAuditoria(rowData);
                                                    }} />
                                            )
                                        }} />
                                    </DataTable>
                                </div>
                            );
                        })}
                    </div>
                    <div>
                        <Label >Observação</Label>
                        <InputTextarea
                            value={auditoria.observacao} 
                            onChange={(e)=>{setAuditoria({...auditoria, observacao: e.target.value})}}
                            style={{ width: '100%' }} 
                            rows={4} 
                            onBlur={()=>{salvarObservacao()}}
                            />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button type="button" label="Voltar" className="ui-button-info" onClick={() => navigate(-1)}></Button>
                        {auditoria.status !== 'FINALIZADA' && auditoria.status !== "CANCELADA" && podeCancelar ?
                            <Button style={{ marginLeft: 8, color: '#fff', backgroundColor: "#CB1301", borderWidth: 0 }} onClick={() => {
                                setVisibleModalCancelarAuditoria(true);
                            }}>Cancelar auditoria</Button>
                            : null
                        }
                        {auditoria.status !== 'FINALIZADA' && auditoria.status !== "CANCELADA" ?
                            <Button style={{ marginLeft: 8, marginRight: 8, backgroundColor: "#240E92", color: '#fff' }} onClick={() => {
                                finalizarAuditoria();
                            }}>Finalizar auditoria</Button>
                            : null
                        }


                    </div>


                </div>
            </div>
        </div>

    );

}